import React, { Component, Fragment } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import i18n from '../../../../i18n/i18n.js';
import TransactionItem from '../History/TransactionItem';

type Props = {
    language: string,
    subscriptions: {
        collection: array,
        total: number,
    },
    setUnsubscribeForm: Function,
    fetchSubscriptions: Function,
};

type State = {
    content: array,
    page: number,
    hasMore: boolean,
};

export default class SubscriptionsForm extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            content: [],
            page: 2,
            hasMore: true,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        this.setState({
            content: nextProps.subscriptions.collection.map(item => 0),
        });
    }

    handleContentClick = index => {
        let sliced = this.state.content.slice();
        sliced[index] = 1 - this.state.content[index];

        this.setState({
            content: sliced,
        });
    };

    fetchMoreHistory = () => {
        this.props.fetchSubscriptions(false, this.state.page);

        this.setState({
            page: this.state.page + 1,
        });
    };

    fetchMoreData = () => {
        const { subscriptions } = this.props;

        if (
            subscriptions.page !== 0 &&
            subscriptions.collection.length === subscriptions.total
        ) {
            this.setState({ hasMore: false });
            return;
        }

        // a fake async api call like which sends
        // 20 more records in .5 secs
        setTimeout(() => {
            this.fetchMoreHistory();
        }, 500);
    };

    render() {
        const lng = this.props.lng;
        const items = this.props.subscriptions.collection;

        const subscriptions = items
            .filter(
                item =>
                    item.status === 'recurrent' || item.status === 'free-trial'
            )
            .map((item, index) => {
                return (
                    <TransactionItem
                        key={index}
                        handleContentClick={this.handleContentClick}
                        content={this.state.content}
                        item={item}
                        index={index}
                        lng={lng}
                        subscriptionsData={true}
                        handleUnsubscribe={this.props.setUnsubscribeForm}
                    />
                );
            });

        return (
            <Fragment>
                <div className="subscriptionsrows">
                    <h4>{i18n.t('subscriptions_active', { lng })}:</h4>
                    {items.length !== 0 ? (
                        <InfiniteScroll
                            dataLength={items.length}
                            next={this.fetchMoreData}
                            hasMore={this.state.hasMore}
                            loader={
                                this.props.subscriptions.total > 5 &&
                                items.length !==
                                    this.props.subscriptions.total && (
                                    <h4>Loading...</h4>
                                )
                            }
                            height={190}
                            endMessage={
                                this.props.subscriptions.total > 5 &&
                                items.length ===
                                    this.props.subscriptions.total && (
                                    <p>
                                        <b>
                                            {i18n.t('no_subscriptions', {
                                                lng,
                                            })}
                                        </b>
                                    </p>
                                )
                            }
                        >
                            {' '}
                            <div className="acc-container">
                                <div className="headrow">
                                    <span>{i18n.t('name', { lng })}</span>
                                    <span>
                                        {i18n.t('next_transaction', { lng })}
                                    </span>
                                </div>
                                {subscriptions}
                            </div>
                        </InfiniteScroll>
                    ) : (
                        <span style={{ fontStyle: 'italic' }}>
                            {i18n.t('no_available_subscriptions', { lng })}
                        </span>
                    )}
                </div>
            </Fragment>
        );
    }
}

export const mapStateToProps = state => {
    return {
        language: state.auth.language,
    };
};



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Subscriptions/index.js